import { CustomerSettingsManager } from './CustomerSettingsManager';
import { FeatureFlagManager } from './FeatureFlagManager';
import { OidcProviderSetup } from './OidcProviderSetup';
import React from 'react';
export const ConfigurationPanel = ({ customer, searchDetails }) => React.createElement(React.Fragment, null,
    React.createElement(OidcProviderSetup, { customerId: customer === null || customer === void 0 ? void 0 : customer.id, shardName: searchDetails === null || searchDetails === void 0 ? void 0 : searchDetails.shardName }),
    React.createElement(CustomerSettingsManager, { customer: customer, searchDetails: searchDetails }),
    React.createElement(FeatureFlagManager, { searchDetails: searchDetails }));
